import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
import Dashboard from "./Dashboard";
import ScriptInsert from "./ScriptInsert";
import GenerateVideoPage from "./GenerateVideoPage";
import FilterComponent from "./components/FilterComponent";
import ProductVideos from "./components/ProductVideos";
import AppLayout from "./components/Layout/AppLayout";
import MakeUGC from "./components/MakeUGC";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AddCharacterPage from "./AddCharacterPage";
import BatchAddCharacterPage from "./BatchAddCharacterPage";
import ViewAvatarsPage from "./ViewAvatarsPage";
import VideoJobsPage from "./VideoJobsPage";
import VideoJobDetailPage from "./VideoJobDetailPage";
import PricingPage from "./PricingPage";
import CheckoutPage from "./CheckoutPage";
import PaymentSuccessPage from "./PaymentSuccessPage";
import FAQSection from "./components/FAQSection";
import StartPage from "./StartPage";
import LoginPage from "./components/LoginPage";
import AccountPage from "./components/Account";
import AdminJobsPage from "./AdminJobsPage";
import VideoFeedbackPage from "./VideoFeedbackPage";
import LeadMagnetPage from "./LeadMagnetPage";
import HookVideosPage from "./HookVideosPage";
import ManageHookVideosPage from "./ManageHookVideosPage";
import Survey from "./components/Survey";
// Helper component to handle the OAuth callback
function AuthCallback() {
  const location = useLocation();
  const { refreshUserData } = useAuth();

  useEffect(() => {
    // Get the token from URL query parameters
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      // Store the token in localStorage
      localStorage.setItem("auth_token", token);
      // Refresh user data with the new token
      refreshUserData();
    }
  }, [location, refreshUserData]);

  // Redirect to dashboard after processing the token
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/makeugc" element={<MakeUGC />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/survey" element={<Survey />} />
          <Route path="/free-videos" element={<LeadMagnetPage />} />

          <Route path="/start" element={<StartPage />} />
          {/* Protected routes with AppLayout */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/account" element={<AccountPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/app" element={<Dashboard />} />
              <Route path="/script-insert" element={<ScriptInsert />} />
              <Route
                path="/generate-product-video"
                element={<GenerateVideoPage itemType="product" />}
              />
              <Route
                path="/generate-talking-video"
                element={<GenerateVideoPage itemType="talking" />}
              />
              <Route path="/video-jobs" element={<VideoJobsPage />} />
              <Route
                path="/video-jobs/project/:projectId"
                element={<VideoJobsPage />}
              />
              <Route
                path="/video-jobs/:jobId"
                element={<VideoJobDetailPage />}
              />
              <Route path="/filter" element={<FilterComponent />} />
              <Route
                path="/product-videos"
                element={<ProductVideos itemType="product" />}
              />
              <Route
                path="/talking-videos"
                element={
                  <div>
                    <ProductVideos itemType="talking" />
                  </div>
                }
              />
              <Route path="/avatars" element={<ViewAvatarsPage />} />
              <Route path="/hook-videos" element={<HookVideosPage />} />
              <Route
                path="/manage-hook-videos"
                element={<ManageHookVideosPage />}
              />
              <Route path="/faq" element={<FAQSection />} />
              <Route
                path="/affiliate"
                element={<div className="p-6">Affiliate Content</div>}
              />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/discord" element={<></>} />
              <Route path="/add-character" element={<AddCharacterPage />} />
              <Route
                path="/batch-add-character"
                element={<BatchAddCharacterPage />}
              />
              <Route path="/admin-jobs" element={<AdminJobsPage />} />
              <Route path="/video-feedback" element={<VideoFeedbackPage />} />
              <Route path="/pricing" element={<PricingPage />} />
            </Route>
            <Route path="/pricing-wall" element={<PricingPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
